import * as React from "react";
import { ScrollView } from "react-native-gesture-handler";
import Carousel, { ICarouselInstance } from "react-native-reanimated-carousel";
import { SafeAreaView } from "react-native-safe-area-context";
import { ImageStyle, Platform, Pressable, StyleProp, Text, View } from 'react-native';
import { SBItem } from "./components/SBItem";
import SButton from "./components/SButton";
import { ElementsText, window } from "./constants";
import { FontAwesome } from '@expo/vector-icons';

const PAGE_WIDTH = window.width;

type HorizontalCarouselType = {
  images: Array<string>;
  width?: number;
  height?: number
  showArrows?: boolean;
  imageStyle?: StyleProp<ImageStyle>,
  removeSampleMark?: boolean;
  arrowsOnBottom?: boolean;
  withShadow?: boolean;
  autoPlay?: boolean;
  capHeader?: string;
  capDescription?: string;
}

const HorizontalCarousel = ({ autoPlay = true, withShadow, arrowsOnBottom, images, width, height, showArrows, imageStyle, removeSampleMark, capDescription, capHeader }: HorizontalCarouselType) => {
  const [data, setData] = React.useState([...new Array(4).keys()]);
  const [isVertical, setIsVertical] = React.useState(false);
  const [isFast, setIsFast] = React.useState(false);
  const [isPagingEnabled, setIsPagingEnabled] = React.useState(true);
  const ref = React.useRef<ICarouselInstance>(null);


  const baseOptions = isVertical
    ? ({
      vertical: true,
      width: PAGE_WIDTH,
      height: PAGE_WIDTH / 2,
    } as const)
    : ({
      vertical: false,
      width: PAGE_WIDTH,
      height: PAGE_WIDTH,
    } as const);

  React.useEffect(() => {
    if (!images?.length) {
      setData["test"]
    } else setData(images);

    return () => {
      ref.current?.stopAutoPlay?.();
      //Cleanup list

    }
  }, []);


  return (
    <View style={{ flex: 1, flexDirection: !arrowsOnBottom ? 'row' : "column", alignSelf: 'stretch', maxWidth: width || '100%', maxHeight: height || undefined }}>
      {
        showArrows && !arrowsOnBottom &&
        <Pressable onPress={() => ref.current?.prev()} style={{ zIndex: 1, left: -5, maxWidth: 50, justifyContent: 'center', top: 15 }}>
          <FontAwesome name="chevron-left" size={50} color={"rgb(90,192,234)"} />
        </Pressable>
      }
      {
        !images?.length && !removeSampleMark &&
        <View style={{ borderRadius: 5, padding: 10, pointerEvents: 'none', position: 'absolute', alignSelf: 'center', justifyContent: 'center', zIndex: 10, backgroundColor: '#00000086', margin: 20 }}>
          <Text style={{ color: 'white', fontSize: 24, fontWeight: 'bold' }}>{capHeader || "Sample Images"}</Text>
          <Text style={{ color: 'white', maxWidth: 150 }}>{capDescription || "This item does not have any images"}</Text>
        </View>
      }
      <View style={{ shadowRadius: 20, borderRadius: 20, shadowOpacity: withShadow ? 0.2 : 0, padding: 2, maxWidth: width * 0.8 || "100%", maxHeight: height * 0.87 || "100%" }}>
      <Carousel
        {...baseOptions}
        loop
        ref={ref}
        testID={"hc"}
        style={{ maxHeight: height || undefined, maxWidth: width || '100%' }}
        snapEnabled
        autoPlay={autoPlay}
        autoPlayInterval={isFast ? 100 : 2000}
        data={data}
        pagingEnabled={isPagingEnabled}
        renderItem={({ item, index }) => <SBItem imageStyle={imageStyle} item={item} key={index} index={index} removeSampleMark={removeSampleMark} />}
      />
      </View>
      <View style={{ zIndex: -1 }}>
      {
          arrowsOnBottom && Platform.OS === 'web' &&
          <View style={{ flex: 1, maxWidth: width, height: 40, top: -10, backgroundColor: 'grey', borderRadius: 20, borderTopStartRadius: 0, borderTopEndRadius: 0, marginHorizontal: "4%", paddingHorizontal: 30, bottom: 0, maxHeight: 50, minWidth: "92%", flexDirection: 'row', position: "absolute", justifyContent: 'center', alignSelf: 'stretch', alignContent: "space-around", alignItems: "stretch", zIndex: 10 }}>
            <Pressable onPress={() => ref.current?.prev()} style={{ flex: 1, zIndex: 1, left: -5, maxWidth: 50, justifyContent: 'center' }}>
              <FontAwesome name="chevron-left" size={20} color={"rgb(90,192,234)"} />
            </Pressable>
            <View style={{ flex: 3 }} />
            <Pressable onPress={() => ref.current?.next()} style={{ flex: 1, maxWidth: 50, justifyContent: 'center', left: -10 }}>
              <FontAwesome name="chevron-right" size={20} color={"rgb(90,192,234)"} />
            </Pressable>
          </View>
        }
      </View>
      {
        showArrows && !arrowsOnBottom &&
        <Pressable onPress={() => ref.current?.next()} style={{ maxWidth: 50, justifyContent: 'center', top: 15, left: -50 }}>
          <FontAwesome name="chevron-right" size={50} color={"rgb(90,192,234)"} />
        </Pressable>
      }
    </View>
  );
}

export default HorizontalCarousel;